"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_NOTIFICATIONS_IN_TOP_BAR = exports.USE_MESSAGES_NOTIFICATIONS_IN_TOP_BAR = exports.STATIC_PATH = exports.SHOW_ITEMS_IN_BOTTOM_BAR = exports.SHOWN_ITEMS_IN_BOTTOM_BAR = exports.PRODUCTS_PER_PAGE = exports.PHONE_MIN_LENGTH = exports.NAVBAR_LOGO_PATH = exports.NAME_ORDER_IN_CHAT = exports.LOGO_PATH = exports.LOGO_LINK_URL = exports.LOGO_LINK = exports.HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES = exports.GOOGLE_TRANSLATE_API_KEY = exports.EMBED_USED_TO_FETCH_USER = exports.DEFAULT_LOCALE = exports.CLOSE_DRAWER_WITHOUT_ICONS = exports.BASE_URL = exports.BASE_API_URL = void 0;
var _Utils = require("../Utils");
var BASE_URL = (0, _Utils.getBackendConfig)('REACT_BASE_URL', process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var STATIC_PATH = process.env.PUBLIC_URL || '';

// we use NAVBAR_LOGO_PATH to define the path of logo of navbar
// example REACT_APP_NAVBAR_LOGO_PATH = 'logos/logo.png'
exports.STATIC_PATH = STATIC_PATH;
var NAVBAR_LOGO_PATH = process.env.REACT_APP_NAVBAR_LOGO_PATH ? "".concat(STATIC_PATH, "/assets/images/").concat(process.env.REACT_APP_NAVBAR_LOGO_PATH) : undefined;
exports.NAVBAR_LOGO_PATH = NAVBAR_LOGO_PATH;
var PRODUCTS_PER_PAGE = process.env.REACT_APP_PRODUCTS_PER_PAGE || 9;
// we use LOGO_PATH to define the path of logo of register and login pages
// example REACT_APP_LOGO_PATH = 'logos/logo.png'
exports.PRODUCTS_PER_PAGE = PRODUCTS_PER_PAGE;
var LOGO_PATH = process.env.REACT_APP_LOGO_PATH ? "".concat(STATIC_PATH, "/assets/images/").concat(process.env.REACT_APP_LOGO_PATH) : undefined;
exports.LOGO_PATH = LOGO_PATH;
var LOGO_LINK = process.env.REACT_APP_LOGO_LINK || false;
exports.LOGO_LINK = LOGO_LINK;
var LOGO_LINK_URL = process.env.REACT_APP_LOGO_LINK_URL || false;
exports.LOGO_LINK_URL = LOGO_LINK_URL;
var GOOGLE_TRANSLATE_API_KEY = process.env.REACT_APP_PUBLIC_GOOGLE_TRANSLATE_API_KEY;
exports.GOOGLE_TRANSLATE_API_KEY = GOOGLE_TRANSLATE_API_KEY;
var DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || 'fr';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var USE_NOTIFICATIONS_IN_TOP_BAR = process.env.REACT_APP_USE_NOTIFICATIONS_IN_TOP_BAR || false;
exports.USE_NOTIFICATIONS_IN_TOP_BAR = USE_NOTIFICATIONS_IN_TOP_BAR;
var USE_MESSAGES_NOTIFICATIONS_IN_TOP_BAR = process.env.REACT_APP_USE_MESSAGES_NOTIFICATIONS_IN_TOP_BAR || false;
exports.USE_MESSAGES_NOTIFICATIONS_IN_TOP_BAR = USE_MESSAGES_NOTIFICATIONS_IN_TOP_BAR;
var SHOWN_ITEMS_IN_BOTTOM_BAR = process.env.REACT_APP_SHOWN_ITEMS_IN_BOTTOM_BAR ? JSON.parse(process.env.REACT_APP_SHOWN_ITEMS_IN_BOTTOM_BAR) : [{
  link: "/store",
  icon: "assignment_ind",
  external: false
}, {
  link: "/product-salable",
  icon: "add_circle_outline",
  external: false
}, {
  link: "/cart",
  icon: "add_shopping_cart",
  external: false
}];
exports.SHOWN_ITEMS_IN_BOTTOM_BAR = SHOWN_ITEMS_IN_BOTTOM_BAR;
var SHOW_ITEMS_IN_BOTTOM_BAR = process.env.REACT_APP_SHOW_ITEMS_IN_BOTTOM_BAR || true;
exports.SHOW_ITEMS_IN_BOTTOM_BAR = SHOW_ITEMS_IN_BOTTOM_BAR;
var CLOSE_DRAWER_WITHOUT_ICONS = process.env.REACT_APP_CLOSE_DRAWER_WITHOUT_ICONS || false;
exports.CLOSE_DRAWER_WITHOUT_ICONS = CLOSE_DRAWER_WITHOUT_ICONS;
var EMBED_USED_TO_FETCH_USER = JSON.parse(process.env.REACT_APP_EMBED_USED_TO_FETCH_USER || "[]");
exports.EMBED_USED_TO_FETCH_USER = EMBED_USED_TO_FETCH_USER;
var NAME_ORDER_IN_CHAT = process.env.REACT_APP_NAME_ORDER_IN_CHAT || "";
exports.NAME_ORDER_IN_CHAT = NAME_ORDER_IN_CHAT;
var HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES = process.env.REACT_APP_HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES ? JSON.parse(process.env.REACT_APP_HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES) : [];
exports.HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES = HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES;
var PHONE_MIN_LENGTH = 4;
exports.PHONE_MIN_LENGTH = PHONE_MIN_LENGTH;